import { useContext } from "react";
import Valve from "../components/Valve";
import Transmitter from "../components/Transmitter";
import "./PigReceiver.css";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import { useState, useEffect } from "react";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import { usePig } from "../components/PigEngine";


import { trackPageVisit } from "../competency/PageTracker";
import TransmitterFaceplate from "../components/TransmitterFaceplate";


/* ================= VALVE OUTPUT ================= */

function ValveOutput({
    tag,
    value,
    x,
    y,
    r = 0,
    description = "Control Valve Opening"
}) {

    const [hover, setHover] = useState(false);
    const [showFaceplate, setShowFaceplate] = useState(false);

    return (
        <>
            {/* Hover */}
            {hover && (
                <div
                    style={{
                        position: "absolute",
                        left: x + 30,
                        top: y - 5,
                        background: "rgba(0,80,180,.85)",
                        color: "#fff",
                        padding: "5px 8px",
                        borderRadius: "4px",
                        border: "1px solid #4fc3ff",
                        fontSize: "11px",
                        zIndex: 9999,
                        pointerEvents: "none",
                        whiteSpace: "nowrap"
                    }}
                >
                    <strong>{tag}</strong><br />
                    {description}
                </div>
            )}

            {/* Original Valve Output */}
            <div
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => setShowFaceplate(true)}
                style={{
                    position: "absolute",
                    left: x,
                    top: y,

                    color: "lime",
                    background: "black",

                    fontSize: "10px",
                    padding: "1px 4px",

                    borderRadius: "4px",
                    border: "1px solid #555",

                    transform: `rotate(${r}deg)`,
                    transformOrigin: "center",

                    cursor: "pointer",

                    fontWeight: "bold",

                    minWidth: "22px",
                    textAlign: "center",

                    transition: "0.2s",
                    boxShadow: hover
                        ? "0 0 8px rgba(0,255,255,.7)"
                        : "none"
                }}
            >
                {Number(value).toFixed(1)} %
            </div>

            {showFaceplate && (
                <TransmitterFaceplate
                    tag={tag}
                    value={Number(value)}
                    unit="%"
                    min={0}
                    max={100}
                    HH={100}
                    H={90}
                    L={10}
                    LL={0}
                    description={description}
                    x={x + 35}
                    y={y + 20}
                    onClose={() => setShowFaceplate(false)}
                />
            )}
        </>
    );
}


function PigReceiver() {

        useEffect(() => {
  
    trackPageVisit("PigReceiver");
  
  }, []);


  const [hoveredValve, setHoveredValve] = useState(null);

  

const tagStyle = {
      position: "absolute",
      top: -30,
      left: "50%",
      transform: "translateX(-50%)",

      background: "black",
      color: "#00ffcc",

      fontSize: "13px",
      fontWeight: "bold",

      padding: "3px 8px",
      borderRadius: "4px",

      border: "1px solid #555",

      whiteSpace: "nowrap",
      zIndex: 999
    };




  const {  valves, toggleValve } = useContext(WellContext);

  const [, forceRender] = useState(0);

useEffect(() => {

  const renderLoop = setInterval(() => {

    forceRender(v => v + 1);

  }, 30);

  return () => clearInterval(renderLoop);

}, []);



     const [valveData, setValveData] = useState(() => {
    const saved = localStorage.getItem("PigReceiver_valveData");
    return saved
      ? JSON.parse(saved)
      : {
            FCV_1801: { mode: "Manual", opening: 0, sp: "", pv: "" },
            FCV_1802: { mode: "Manual", opening: 0, sp: "", pv: "" },

            };
        });



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("PigReceiver_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
    setValveData(prev => ({
      ...prev,
      [tag]: {
        ...prev[tag],
        [field]: field === "opening" ? Number(value) || 0 : value
      }
    }));
  };

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };




const {
  pigLoaded,
  pigType,
  pigVisible,
  pigX,
  pigY,
  pigPage,
  pigPaused,
  removePig
} = usePig();




 const isXV1801Open = valves?.XV_1801 === false;
 const isXV1802Open = valves?.XV_1802 === false;
 const isXV1803Open = valves?.XV_1803 === false;



   /* ================= LOCAL DCS SIMULATION ================= */

  // Receiver flow (decays after pig arrival)
  const FIC_1803 =
    isXV1801Open && isXV1802Open
      ? 250
      : isXV1801Open
        ? 450
        : 0;

  // Line pressure after transfer
  const PT_1802 =
    pigPaused ? 3.1 : 1.2;

  // Pig barrel pressure (build-up when blocked)
  const PT_1801 =
    pigPaused
      ? 2.8
      : 1.2;

  // Temperature rises slightly during flow restriction
  const TT_1801 = pigPaused ? 
    41  : 38 + (FIC_1803 / 30);

  // Valve position indicators (ZT)
  const ZT_1801 = isXV1801Open ? 1 : 0;


  const FIC_1801 = 20 * (valveData.FCV_1801.opening)/100;
  const FIC_1806 = isXV1803Open ? FIC_1801 : 0;
  const FIC_1804 = 150 * (valveData.FCV_1802.opening)/100;





      useEffect(() => {
  localStorage.setItem("isXV1801Open", isXV1801Open);
  localStorage.setItem("isXV1802Open", isXV1802Open);
 
}, [
  isXV1801Open,
  isXV1802Open,

]);





  return (
    <div className="PigReceiver-container">
      {/* TITLE */}
      <h2 style={{
        position: "absolute",
        top: "-18px",
        left: "252px",
        color: "white",
        background: "rgb(30, 5, 250)",
        padding: "2.2px 301px"
      }}>
        PIG RECEIVER
      </h2>


    {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-10905 */}
      <Valve
        className="XV-1801"
        tag="XV_1801"
        x={685}
        y={236}
        isClosed={valves.XV_1801}
        toggle={toggleValve}
      />

            {/* XV-1802 */}
      <Valve
        className="XV-1802"
        tag="XV_1802"
        x={1053}
        y={300}
        isClosed={valves.XV_1802}
        toggle={toggleValve}
        r={90}
      />

      
      {/* XV-1803 */}
      <Valve
        className="XV-1803"
        tag="XV_1803"
        x={928}
        y={461}
        isClosed={valves.XV_1803}
        toggle={toggleValve}
      />




      {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-1801 */}
        <div
            style={{ position: "absolute", left: 157, top: 52}}
            onMouseEnter={() => setHoveredValve("FCV_1801")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_1801")}
          >

            {hoveredValve === "FCV_1801" && (
              <div style={tagStyle}>
                FCV_1801
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-1801">
                    
          <defs>
            <linearGradient id="metal_1801">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_1801)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_1801)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      

        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-1802 */}
        <div
            style={{ position: "absolute", left: 1035, top: 75}}
            onMouseEnter={() => setHoveredValve("FCV_1802")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_1802")}
          >

            {hoveredValve === "FCV_1802" && (
              <div style={tagStyle}>
                FCV_1802
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-1802">
                    
          <defs>
            <linearGradient id="metal_1802">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_1802)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_1802)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      


     
      {/* ================= FACEPLATES ================= */}
      {openPanels.map((tag, index) => (
        <ControlValveControlPanel
          key={tag}
          tag={tag}
          data={valveData[tag]}
          update={updateValveData}   // ✅ FIXED
          close={() => closePanel(tag)}
          defaultPosition={{
            x: 300 + index * 40,
            y: 150 + index * 40
          }}
        />
      ))}





      <div
          onClick={removePig}
          style={{
            position:"absolute",
            left: 20,
            top: 230,
            padding:"10px 10px",
            background: "#222",
            color: "white",
            cursor: "pointer",
            border:"2px solid cyan",
            borderRadius: "6px",
            zIndex: 5000,
            userSelect: "none",
            transition: "0.3s"
          }}
        >
          Remove Pig
        </div>


        {
          pigVisible &&
          pigPage === "receiver" && (

            <svg
              style={{
                position:"absolute",
                left: pigX,
                top: pigY,
                overflow:"visible",
              }}
              width={
                pigType === "rect"
                  ? 60
                  : 35
              }

              height={
                pigType === "rect"
                  ? 30
                  : 35
              }
            >

              {
                pigType === "rect" ? (

                  <rect
                    x="0"
                    y="0"
                    rx="10"
                    ry="10"
                    width="60"
                    height="30"
                    fill="red"
                    stroke="lime"
                    strokeWidth="2"
                  />

                ) : (

                  <circle
                    cx="15"
                    cy="15"
                    r="10"
                    fill="yellow"
                    stroke="black"
                    strokeWidth="2"
                  />

                )
              }

            </svg>
          )
        }

        <div
          style={{
            position: "absolute",
            left: pigX,
            top: pigY - 20,
            color: "yellow",
            zIndex: 9999
          }}
        >
          X:{Math.round(pigX)} Y:{Math.round(pigY)}
        </div>


      {/* ================= CONTROL VALVE OUTPUTS ================= */}

      <ValveOutput
        value={valveData.FCV_1801.opening}
        x={180}
        y={101}
      />

       <ValveOutput
        value={valveData.FCV_1802.opening}
        x={1057}
        y={120}
      />








      {/* Flow in receiver line */}
      <Transmitter
        tag="FIC-1803"
        value={[FIC_1803]}
        x={1085}
        y={220}
        unit="SCF/S"
        max={500}
        HH={450}
        H={350}
        L={100}
        LL={20}
        c="cyan"
        description="FLOW INTO PIG RECEIVER HEADER"
      />

      {/* Receiver barrel pressure */}
      <Transmitter
        tag="PT-1801"
        value={[PT_1801]}
        x={195}
        y={220}
        unit="MPa"
        max={3}
        HH={2.5}
        H={2}
        L={0.5}
        LL={0.1}
        c="lime"
        description="PIG RECEIVER BARREL PRESSURE"
      />

      {/* Line pressure after branch */}
      <Transmitter
        tag="PT-1802"
        value={[PT_1802]}
        x={895}
        y={220}
        unit="MPa"
        max={3}
        HH={2.5}
        H={2}
        L={0.5}
        LL={0.1}
        c="lime"
        description="DOWNSTREAM LINE PRESSURE AT RECEIVER ENTRY"
      />

      {/* Temperature */}
      <Transmitter
        tag="TT-1801"
        value={[TT_1801]}
        x={800}
        y={220}
        unit="°C"
        max={120}
        HH={90}
        H={70}
        L={20}
        LL={10}
        c="orange"
        description="TEMPERATURE AT RECEIVER SECTION"
      />


      <Transmitter
        tag="FIC-1801"
        value={[FIC_1801]}
        x={284}
        y={49}
        unit="SCF/S"
        max={35}
        HH={30}
        H={25}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF NITROGEN TO PIG RECEIVER FOR PURGING"
      />

      <Transmitter
        tag="FIC-1806"
        value={[FIC_1806]}
        x={539}
        y={443}
        unit="SCF/S"
        max={35}
        HH={30}
        H={25}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF NITROGEN AND FLUIDS/IMPURITIES TO CLOSE DRAIN AFTER PURGING OF PIG RECEIVER BARREL"
      />

      <Transmitter
        tag="FIC-1804"
        value={[FIC_1804]}
        x={922}
        y={113}
        unit="LPM"
        max={180}
        HH={130}
        H={125}
        L={5}
        LL={3}
        c="lime"
        description="FLOWRATE OF PIGGED FLUID FOR EXPORT VIA LOADING BOAT"
      />

     

      

    </div>
  );
}

export default PigReceiver;


